<template>
  <v-row
    class="justify-center align-center"
    style="margin: 0;"
  >
    <v-col
      cols="auto"
      style="padding-right: 0;"
    >
      <v-icon
        class="cursor-pointer"
        @click="onPrevious('month')"
      >
        <<<
      </v-icon>
    </v-col>
    <v-col
      cols="auto"
      style="padding-right: 0;"
    >
      <v-icon
        class="cursor-pointer"
        @click="onPrevious('week')"
      >
        <<
      </v-icon>
    </v-col>
    <v-col
      cols="auto"
    >
      <v-icon
        class="cursor-pointer"
        @click="onPrevious('day')"
      >
        <
      </v-icon>
    </v-col>

    <v-col
      class="main-header-title"
    >
      {{ $t('fleet/vehicle_reservation.overview_of_days').replace(':days', globalConfig && globalConfig.tableConfig && globalConfig.tableConfig.globalConfig && globalConfig.tableConfig.globalConfig.daysToShow ? globalConfig.tableConfig.globalConfig.daysToShow : '30') }}
    </v-col>

    <v-col
      cols="auto"
      style="padding-right: 0;"
    >
      <v-icon
        class="cursor-pointer"
        @click="onNext('day')"
      >
        >
      </v-icon>
    </v-col>
    <v-col
      cols="auto"
      style="padding-right: 0;"
    >
      <v-icon
        class="cursor-pointer"
        @click="onNext('week')"
      >
        >>
      </v-icon>
    </v-col>
    <v-col
      cols="auto"
    >
      <v-icon
        class="cursor-pointer"
        @click="onNext('month')"
      >
        >>>
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DateHeaderWithArrows',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    globalConfig: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    onPrevious (type) {
      const { onPrevious } = this.config || {}

      if (typeof onPrevious === 'function') {
        onPrevious(type)
      }
    },

    onNext (type) {
      const { onNext } = this.config || {}

      if (typeof onNext === 'function') {
        onNext(type)
      }
    }
  }
}
</script>

<style scoped>
.main-header-title {
  text-align: center;
}

.cursor-pointer {
  font-size: 20px !important;
}

.cursor-pointer::after {
  background-color: unset !important;
}

.cursor-pointer:focus::after {
  opacity: unset !important;
  transition: unset !important;
  background-color: unset !important;
}
</style>
